<template>
    <ActionsContainer
        :panelStyle="panelStyle"
        :selectedCount="selectedTo.length"
        :labelCounts="$t('lang.main.table.components.keywords_action.selected_rows')"
    >
        <template #buttons>
            <Button @click="onClickOnlineWsParser" :label="$t('lang.main.table.components.keywords_action.online_ws_parser')" size="small" />
            <Button @click="clearSelectedTo" :label="$t('lang.main.btn.clear')" severity="secondary" size="small" />
        </template>
    </ActionsContainer>
</template>

<script>

import Clipboard from "../../../mixins/Clipboard";
import {nextTick} from "vue";
import ActionsContainer from "./actions-container.vue";
import Button from "primevue/button";
import {Listeners} from "../../../constants/listeners";

export default {
    mixins: [Clipboard],
    data() {
        return {
            rollUp: false,
            style: {},
            selectedTo: [],
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    },
    mounted() {
        this.$emitter.on(Listeners.KS_TABLE_CHECKBOX_SELECTED, eventData => this.selectedTo = eventData);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        onClickOnlineWsParser() {
            let ids = this.selectedTo.slice();
            window.open("/" + window.locale + "/wordstat-list/?kids=" + ids.join(), '_blank');
        },
        clearSelectedTo() {
            this.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
        },
        handleScroll() {
            if (document.getElementsByClassName('ks-button-panel').length === 0) {
                return;
            }

            let table = document.getElementsByClassName('vuetable')[0];
            if ((window.innerHeight - 200) >= (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70)) {
                this.style = {
                    top: (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70) + 'px',
                }
            } else {
                this.style = {
                    top: (window.innerHeight - 200) + 'px'
                };
            }
        }
    },
    computed: {
        panelStyle() {
            return Object.assign({}, this.style, this.rollUp?{padding: '15px', opacity: 0.5}:{});
        },

    },
    watch: {
        selectedTo() {
            let self = this;
            nextTick(() => {
                self.handleScroll();
            });
        }
    },
    components: {
        ActionsContainer,
        Button,
    }
}
</script>
